// Entity + scoring spec. Every value here was playtested in the prototype — do not
// change without asking Rebecca (CLAUDE.md §3 / §8).
import type { Prio } from './types';

export interface PrioSpec {
  pts: number;
  color: string;
  txt: string;
  speed: number;
  size: number;
}

export const PRIO: Record<Prio, PrioSpec> = {
  P0: { pts: 50, color: '#e5484d', txt: '#fff', speed: 1.5, size: 0.72 },
  P1: { pts: 30, color: '#f76b15', txt: '#fff', speed: 1.25, size: 0.85 },
  P2: { pts: 20, color: '#ffc53d', txt: '#3a2c00', speed: 1.1, size: 0.95 },
  P3: { pts: 15, color: '#46a758', txt: '#fff', speed: 1.0, size: 1 },
  P4: { pts: 10, color: '#3e63dd', txt: '#fff', speed: 0.92, size: 1 },
  P5: { pts: 5, color: '#8b8d98', txt: '#fff', speed: 0.85, size: 1 },
};

// Uniform scale on the ticket radius. Applied to the whole radius so the per-priority size
// ratios (P0 smallest … P5 largest) are preserved exactly. Sprites and hitboxes both derive
// from the entity radius, so they scale together.
export const TICKET_SIZE_MUL = 1.5;

export const ROUND = 60;
export const CRIT_CHANCE = 0.05;
export const CRIT_PTS = 10;
export const MAX_LIVES = 3;
export const MEGA_CAP = 50;
export const MEGA_TIME = 5;

// "Duplicate Storm" mid-round pomegranate
// Airborne size multiplier — the tumbling storm ticket flies 40% larger (sprite + hitbox,
// both from the entity radius). The mash zoom divides this back out so the zoomed-in size is
// unchanged (spec: only the airborne size grows, the zoom moment must not overshoot).
export const POM_AIRBORNE_MUL = 1.4;
export const POM_TIME = 5;
// Not a cap anymore — slicing is unlimited (only the 5s timer limits it). This is the
// milestone at which the one-time "ZERO DUPLICATES! +10" flourish fires (slice.ts).
export const POM_CAP = 50;
export const POM_PTS = 2;

// Live URL used in share copy / the ticket. Update to the custom domain once it's attached.
export const GAME_URL = 'https://ticket-ninja.pages.dev';
